<abi-spinner *ngIf="loading" [indeterminate]="submitting" [value]="uploadProgress"></abi-spinner>

<abi-upload-splash *ngIf="uploadingFiles"></abi-upload-splash>

<form role="form" [formGroup]="form" autocomplete="off" #formElement>
    <!-- Confirmation Page Buttons -->
    <div *ngIf="confirmPage && !loading" class="btn-group float-right">
        <button
            type="button"
            class="btn btn-outline-primary"
            (click)="previousPage()"
        >
            <i class="fas fa-chevron-left"></i>
            {{ "System.Previous" | translate }}
        </button>
        <button
            type="button"
            class="btn btn-outline-primary"
            (click)="finish()"
            data-cy="job-create-confirm-finish"
        >
            <i class="fas fa-check"></i> {{ "System.Finish" | translate }}
        </button>
    </div>

    <ng-container *ngIf="!initialLoad">

    <!-- PRIMARY Navigation -->
    <abi-nav-dropdown [hidden]="confirmPage">
        <div class="btn-group mr-1">
            <button
                *ngIf="firstPage"
                type="button"
                class="btn btn-outline-primary"
                (click)="cancel()"
                [attr.caption]="'System.Cancel' | translate"
            >
                <i class="fas fa-times"></i>
            </button>
        </div>
        <button
            *ngIf="confirmPage"
            type="button"
            class="btn btn-outline-primary"
            (click)="previousPage()"
        >
            <i class="fas fa-chevron-left"></i>
            {{ "System.Previous" | translate }}
        </button>
        <div after class="btn-group ml-1">
            <button
                *ngIf="lastPage"
                type="button"
                class="btn btn-outline-primary"
                (click)="finish()"
            >
                <i class="fas fa-check"></i> {{ "System.Finish" | translate }}
            </button>
        </div>

        <ul
            ngbNav
            #nav="ngbNav"
            class="nav-pills"
            [activeId]="activePage"
            [destroyOnHide]="false"
            (navChange)="beforeChange($event)"
            (activeIdChange)="afterChange($event)"
        >
            <li ngbNavItem="source" *ngIf="sources?.length > 1">
                <a ngbNavLink
                    >{{ "Job.Source" | translate }}
                    <abi-group-status
                        [group]="form.controls.source"
                        [name]="'source'"
                    ></abi-group-status
                ></a>
                <ng-template ngbNavContent>
                    <!-- <pre>
                        {{ availableSources | json }}
                        {{ form.controls.source.value | json }}
                    </pre> -->
                    <div class="row" formGroupName="source">
                        <abi-form-field
                            label="JobNew.Source"
                            [errors]="formErrors.sourceId"
                        >
                            <abi-job-source-select
                                formControlName="sourceId"
                            ></abi-job-source-select>
                        </abi-form-field>
                    </div>
                    <div class="row" formGroupName="source">
                        <abi-form-field
                            label="Customer.Consent"
                            [errors]="formErrors.consent"
                            [wrap]="true"
                        >
                            <select
                                formControlName="consent"
                                class="custom-select"
                            >
                                <option
                                    value=""
                                    disabled
                                    selected
                                    translate="Customer.ConsentPrompt"
                                ></option>
                                <option
                                    value="YES"
                                    translate="System.Yes"
                                ></option>
                                <option
                                    value="NO"
                                    translate="System.No"
                                ></option>
                                <option
                                    value="JOB"
                                    translate="Job.Dealer"
                                ></option>
                            </select>
                        </abi-form-field>
                    </div>
                </ng-template>
            </li>

            <li ngbNavItem="contact">
                <a ngbNavLink
                    >{{ "Job.Contact" | translate }}
                    <abi-group-status
                        [group]="form.controls.contact"
                        [name]="'contact'"
                    ></abi-group-status
                ></a>
                <ng-template ngbNavContent>
                    <div class="row">
                        <abi-form-field label="JobNew.Choose">
                            <select
                                formControlName="contactId"
                                id="contactId"
                                class="custom-select"
                            >
                                <option
                                    *ngFor="let cc of customer?.contacts"
                                    [ngValue]="cc"
                                >
                                    {{ contactName(cc) | translate }}
                                </option>
                            </select>
                        </abi-form-field>
                    </div>
                    <mat-divider class="mb-3"></mat-divider>
                    <abi-contact [ngModel]="currentContact" [ngModelOptions]="{standalone: true}" [group]="form.controls.contact" type="Customer" context="Job"></abi-contact>
                </ng-template>
            </li>

            <li ngbNavItem="address">
                <a ngbNavLink
                    >{{ "Job.Address" | translate }}
                    <abi-group-status
                        [group]="form.controls.address"
                        name="address"
                    ></abi-group-status
                ></a>
                <ng-template ngbNavContent>
                    <div class="row">
                        <abi-form-field label="JobNew.Choose">
                            <select
                                formControlName="addressId"
                                id="addressId"
                                class="custom-select"
                            >
                                <option
                                    *ngFor="let cc of customer?.addresses"
                                    [ngValue]="cc"
                                >
                                    {{ addressName(cc) | translate }}
                                </option>
                            </select>
                        </abi-form-field>
                    </div>

                    <mat-divider class="mb-3"></mat-divider>
                    <abi-address [ngModel]="currentAddress" [ngModelOptions]="{standalone: true}" [group]="form.controls.address"></abi-address>
                </ng-template>
            </li>

            <li ngbNavItem="machine">
                <a ngbNavLink
                    >{{ "Job.Machine" | translate }}
                    <abi-group-status
                        [group]="form.controls.machineMaster"
                        [name]="'machineMaster'"
                    ></abi-group-status
                ></a>
                <ng-template ngbNavContent>
                    <div class="row">
                        <abi-form-field label="JobNew.Choose">
                            <select
                                formControlName="machineId"
                                id="machineId"
                                class="custom-select"
                            >
                                <option
                                    *ngFor="let cc of machines"
                                    [ngValue]="cc.machineId"
                                >
                                    {{ machineName(cc) | translate }}
                                </option>
                            </select>
                        </abi-form-field>
                    </div>
                    <mat-divider class="mb-3"></mat-divider>
                    <abi-machine-master
                        [group]="form.controls.machineMaster"
                        [formErrors]="formErrors"
                        context="Job"
                        (addJournal)="addMachineJournalEntry($event)"
                    >
                    </abi-machine-master>
                </ng-template>
            </li>

            <li ngbNavItem="details">
                <a ngbNavLink
                    >{{ "Job.Service" | translate }}
                    <abi-group-status
                        [group]="form.controls.details"
                        [name]="'details'"
                    ></abi-group-status
                ></a>
                <ng-template ngbNavContent>
                    <div class="row" formGroupName="details">

                        <!-- Job at Branch: should hide typeId and show Diagnostic -->
                        <abi-form-field
                            *ngIf="showField('typeId', true)"
                            label="Job.TypeID"
                            [errors]="formErrors.typeId"
                        >
                            <input
                                formControlName="typeId"
                                abiTypeahead
                                abiLookup="CodeJobType"
                                [preFilter]="jobTypeFilter.bind(this)"
                                [queryPathExtras]="getQueryPathExtras('CodeJobType')"
                                [codeOnly]="true"
                            />
                        </abi-form-field>
                        <div class="w-100"></div>
                        <!-- Job at Branch: should show Diagnostic -->
                        <abi-form-field
                            *ngIf="showField('diagnosticCodeId', false)"
                            label="Job.DiagnosticCodeID"
                        >
                            <input formControlName="diagnosticCodeId"
                                abiTypeahead abiLookupQuery="CodeJobDiagnostic"
                                abiProductHint="Job.DiagnosticCodeIDHint"
                                [path]="getQueryPathExtras('CodeJobDiagnostic')"
                                [codeOnly]="true"
                            />
                        </abi-form-field>

                        <div class="w-100"></div>
                        <abi-form-field
                            *ngIf="showField('faultCodeId', true)"
                            label="Job.FaultCodeID"
                            [errors]="formErrors.faultCodeId"
                            [ignoreStatus]="loggedIn ? 0 : 2"
                            [customComponent]="faultCodeComponent"
                            [customData]="form.value"
                            tooltip="Job.FaultCodeIDTooltip"
                            wrap="true"
                        >
                            <input
                                formControlName="faultCodeId"
                                abiTypeahead
                                abiLookupQuery="CodeJobFault"
                                [filter]="filterFaultCodes"
                                [path]="getQueryPathExtras('CodeJobFault')"
                                [codeOnly]="true"
                            />
                        </abi-form-field>

                        <div class="w-100"></div>
                        <abi-form-field
                            *ngIf="showField('faultDescription', true)"
                            label="Job.FaultDescription"
                            [errors]="formErrors.faultDescription"
                            wrap="true"
                        >
                            <textarea
                                formControlName="faultDescription"
                                id="faultDescription"
                            ></textarea>
                        </abi-form-field>
                        <div class="w-100"></div>
                        <abi-form-field
                            *ngIf="showField('customerRef', false)"
                            label="Job.CustomerReference"
                            [errors]="formErrors.customerRef"
                            wrap="true"
                        >
                            <input
                                formControlName="customerRef"
                                type="text"
                            />
                        </abi-form-field>
                        <div class="w-100"></div>
                        <ng-container *ngFor="let i of [1,2,3,4,5]">
                            <abi-form-field [label]="'Job.Field' + i"
                                *ngIf="showField('field'+i, false)"
                                [ignoreStatus]="2">
                                <input *ngIf="getString('JobCustomField' + i + 'Lookup') as lookup; else textOnly" type="text" [formControlName]="'field' + i"
                                abiTypeahead [abiLookup]="lookup" inputDisplay="name" dropDownDisplay="name"/>

                                <ng-template #textOnly>
                                    <input type="text" [formControlName]="'field' + i">
                                </ng-template>
                            </abi-form-field>
                            <div class="w-100"></div>
                        </ng-container>

                        <abi-form-field
                            *ngIf="fileUploadEnabled"
                            label="Job.FileUpload"
                            [errors]="formErrors.faultImages"
                            tooltip="Job.FileUploadTooltip"
                            wrap="true"
                            inputColClass="col-md-8"
                        >
                        <abi-multi-file-upload formControlName="faultImages" [disabled]="false"></abi-multi-file-upload>
                        </abi-form-field>
                        <div class="w-100"></div>

                        <ng-container *ngIf="jobAtBranch && !hideBookingInfo">
                            <!-- <abi-form-field class="mt-4"> -->
                            <h4 class="w-100 mt-4">Booking Info</h4>
                            <p class="mb-2">{{ 'BookingInfo.Description' | translate }}</p>
                            <!-- </abi-form-field> -->
                            <div class="w-100"></div>
                            <abi-form-field label="JobAtBranch.BranchID">
                                <input
                                    id="serviceBranchId"
                                    formControlName="serviceBranchId"
                                    abiTypeahead
                                    abiDealer
                                    container="body"
                                />
                            </abi-form-field>
                            <div class="w-100"></div>

                            <abi-form-field
                                label="JobAtBranch.BookingDate"
                                [errors]="formErrors.serviceDate"
                            >
                                <abi-dateselector
                                    formControlName="serviceDate"
                                    [disableInput]="false"
                                    [calendar]="branchCalendar"
                                ></abi-dateselector>
                            </abi-form-field>
                            <div class="w-100"></div>

                            <abi-form-field
                                label="JobAtBranch.TimeSlot"
                                [errors]="formErrors.serviceTimeSlot"
                            >
                                <div
                                    ngbRadioGroup
                                    class="
                                        btn-group
                                        btn-group-toggle
                                        btn-group-vertical
                                        d-flex
                                    "
                                    name="serviceTimeSlot"
                                    formControlName="serviceTimeSlot"
                                >
                                    <label
                                        *ngFor="
                                            let timeSlot of serviceTimeSlots
                                                | keyvalue
                                        "
                                        ngbButtonLabel
                                        class="btn-outline-primary ml-0 w-100"
                                    >
                                        <input
                                            ngbButton
                                            type="radio"
                                            [value]="timeSlot.key"
                                            [disabled]="
                                                !timeSlot.value.available
                                            "
                                        />{{ timeSlot.value.id }} {{ !timeSlot.value.available ? '(Unavailable)' : ''}}
                                    </label>
                                </div>
                                <ng-container
                                    *ngIf="serviceTimeSlots.size === 0"
                                >
                                    <label class="text-muted">Selection Unavailable</label>
                                </ng-container>
                            </abi-form-field>
                        </ng-container>
                    </div>
                </ng-template>
            </li>

            <li ngbNavItem="dealerContact" *ngIf="showDealerDetails">
                <a ngbNavLink
                    >{{ "Job.Dealer" | translate }}
                    <abi-group-status
                        [group]="form.controls.dealerContact"
                        name="DealerContact"
                    ></abi-group-status
                ></a>
                <ng-template ngbNavContent>
                    <div class="row">
                        <abi-form-field label="">
                            <input
                                formControlName="machineId"
                                style="visibility: hidden"
                            />
                        </abi-form-field>
                    </div>
                    <mat-divider class="mb-3"></mat-divider>
                    <abi-contact
                        [(ngModel)]="currentDealer"
                        [ngModelOptions]="{standalone: true}"
                        [group]="form.controls.dealerContact"
                        [validates]="validateDealer"
                        type="Dealer"
                    ></abi-contact>
                </ng-template>
            </li>
        </ul>
    </abi-nav-dropdown>

    <div [hidden]="confirmPage" class="position-relative">
        <div class="btn-group pt-0 d-none d-md-block nav-buttons">
            <button
                *ngIf="firstPage"
                type="button"
                class="btn btn-outline-primary"
                (click)="cancel()"
            >
                <i class="fas fa-times"></i> {{ "System.Cancel" | translate }}
            </button>
            <button
                *ngIf="!firstPage"
                type="button"
                class="btn btn-outline-primary"
                (click)="previousPage()"
            >
                <i class="fas fa-chevron-left"></i>
                {{ "System.Previous" | translate }}
            </button>
            <button
                *ngIf="!lastPage"
                type="button"
                class="btn btn-outline-primary"
                (click)="nextPage()"
                data-cy="job-create-next"
            >
                {{ "System.Next" | translate }}
                <i class="fas fa-chevron-right"></i>
            </button>
            <button
                *ngIf="lastPage"
                type="button"
                class="btn btn-outline-primary"
                (click)="finish()"
                data-cy="job-create-finish"
            >
                <i class="fas fa-check"></i> {{ "System.Finish" | translate }}
            </button>
        </div>
        <div #navContent [ngbNavOutlet]="nav" class="mt-3"></div>
    </div>

    </ng-container>

    <abi-jobs-confirm
        *ngIf="confirmPage && !loading"
        [job]="job"
        [source]="sourceDescription()"
        [jobAtBranch]="jobAtBranch"
        [fileUploadEnabled]="fileUploadEnabled"
        [files]="allFiles"
    ></abi-jobs-confirm>
</form>

<ng-template #submitted let-modal>
    <div class="modal-header">
        <h4 class="modal-title">
            {{ "JobNew.JobNew" | translate }}: {{ job | job: "cleanJobId" }}
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p translate="JobNew.SubmitMessage"></p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="modal.close()" cdkFocusInitial>
            {{ "JobNew.Ok" | translate }}
        </button>
        <button
            *ngIf="loggedIn && canSchedule"
            type="button"
            class="btn btn-primary"
            (click)="schedule()"
            translate="Job.Schedule"
            data-cy="job-create-schedule"
        ></button>
    </div>
</ng-template>
